// @flow
import React, { useState } from 'react';
import { useFormikContext } from 'formik';
import { BACKEND_FIELDNAMES } from '@streaming-projects/enums';
import { STREAMING_PROJECTS_SP_DETAILS_CONFIG_MAP } from '@streaming-projects/sp-page/config';

import { DateField } from '../../../../formik-utils/FormFields';

import { SPDateChangeWarningModal } from './SPDateChangeWarningModal';

export const SPRampedDateContainer = ({
  disableOnFormErrors = null,
  showWarningOnChange = true,
}) => {
  const { initialValues } = useFormikContext();
  const [isDateChangeWarningModalOpen, setDateChangeWarningModalOpen] = useState(false);

  const { backendFieldName, displayName } = STREAMING_PROJECTS_SP_DETAILS_CONFIG_MAP.get(
    BACKEND_FIELDNAMES.SP_RAMPED_DATE
  );

  return (
    <>
      {showWarningOnChange && (
        <SPDateChangeWarningModal
          isOpen={isDateChangeWarningModalOpen}
          setOpen={setDateChangeWarningModalOpen}
        />
      )}

      <DateField
        clearable={true}
        disableOnFormErrors={disableOnFormErrors}
        fieldDisplayName={displayName}
        fieldName={backendFieldName}
        fluid={true}
        onChange={(event, value) => {
          if (showWarningOnChange && value !== initialValues.ramp_date) {
            setDateChangeWarningModalOpen(true);
          }
        }}
      />
    </>
  );
};
